import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";

export default function EditorialMarquee() {
  const words = ["UNE IDÉE", "UN CHALLENGE", "UNE APPLICATION"];
  return (
    <div className="border-y border-white/10 bg-void py-6 overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 font-display font-700 text-3xl sm:text-5xl uppercase tracking-tight text-white/60">
            {w}
            <Star size={22} className="text-cyan fill-cyan" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
